export const runtimeEnvironment = {
  BUILD_NUMBER: 'c514363c-66e5-4668-92be-7a9a8dbf76ad',
  SENTRY_ENABLED: true,
};
